import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const UserRedirect = () => {
  const { user, isAdmin, isSupervisor, isOperator } = useAuth();

  if (isAdmin()) return <Navigate to="/admin/dashboard" replace />;
  if (isSupervisor()) return <Navigate to="/supervisor/dashboard" replace />;
  if (isOperator()) return <Navigate to="/operator/session" replace />;
  return <Navigate to="/announce" replace />;
};

export default UserRedirect;
